import { Outlet } from "react-router-dom";
import { Stack, styled } from "@mui/material";

export const TalentLayout = () => {
  return (
    <TalentLayoutWrapper>
      <Outlet />
    </TalentLayoutWrapper>
  );
};

const TalentLayoutWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
